import { Injectable } from '@angular/core';
import { MapService } from 'src/app/vehicles/services/map.service';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import { VehicleHistoryDrawerParams } from '../models/vehicle-history-drawer.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VehicleHistoryDrawerService {
  // Estados del drawer de historial
  private isHiddenSubject = new BehaviorSubject<boolean>(true);
  private isDestroyedHistoryDrawerSubject = new BehaviorSubject<boolean>(true);
  private isFirstEmission = true;
  private dataHistoryDrawerSubject =
    new BehaviorSubject<VehicleHistoryDrawerParams | null>(null);

  // private commandsSubmit = new Map()

  constructor(mapService: MapService) {
    mapService.onClickHistoryButton
      .pipe(
        tap((_) => {
          this.managerFirstEmission();
        }),
        distinctUntilChanged((previous, current) =>
          this.managerDistinctUntilChanged(previous, current)
        ),
        tap((data: VehicleHistoryDrawerParams) => {
          this.dataHistoryDrawerSubject.next(data);
        })
      )
      .subscribe();

      mapService.onClickCommandButton
      .pipe(
        
      )
      .subscribe();
  }

  get getStateHiddenHistoryDrawer() {
    return this.isHiddenSubject.asObservable();
  }

  get getStateDestroyedHistoryDrawer() {
    return this.isDestroyedHistoryDrawerSubject.asObservable();
  }

  set setStateHiddenHistoryDrawer(value: boolean) {
    this.isHiddenSubject.next(value);
  }

  set setStateDestroyedHistoryDrawer(value: boolean) {
    this.isDestroyedHistoryDrawerSubject.next(value);
  }

  get getDataHistoryDrawer() {
    return this.dataHistoryDrawerSubject.asObservable();
  }

  private get isDestroyedHistoryDrawer(): boolean {
    return this.isDestroyedHistoryDrawerSubject.value;
  }

  private get isHiddenHistoryDrawer(): boolean {
    return this.isHiddenSubject.value;
  }

  private managerDistinctUntilChanged(
    previous: VehicleHistoryDrawerParams,
    current: VehicleHistoryDrawerParams
  ): boolean {
    // Si el drawer está destruido, emitir el evento completo
    if (this.isDestroyedHistoryDrawer) {
      this.setStateDestroyedHistoryDrawer = false;
      this.setStateHiddenHistoryDrawer = false;
      return false;
    }

    // SI NO ES CUSTOM, REALIZAMOS LA LOGICA DE COMPARACION DE ESTADOS
    if (!current.is_custom) {
      // Si los valores son iguales, solo emitir el evento hidden
      const isSameState = previous.is_custom === current.is_custom;
      const isSameImei = previous.imei === current.imei;
      if (isSameState && isSameImei) {
        if (this.isHiddenHistoryDrawer) {
          this.setStateHiddenHistoryDrawer = false;
        }
        return true;
      }
    }

    // Si los valores son diferentes, emitir el evento completo
    this.setStateDestroyedHistoryDrawer = false;
    this.setStateHiddenHistoryDrawer = false;
    return false;
  }

  private managerFirstEmission() {
    if (this.isFirstEmission) {
      this.isFirstEmission = false;
      this.setStateDestroyedHistoryDrawer = false;
      this.setStateHiddenHistoryDrawer = false;
    }
  }
}
